
const rutasMapasSVG = [
//SVG
/*{
    name: "svg_arbustos_posicion",
    type: "svg",
    path: "mapa/arbustos_posicion.svg",
  },*/
  
]

export default rutasMapasSVG